import { render, staticRenderFns } from "./InstanceTable.vue?vue&type=template&id=7927155b&scoped=true"
import script from "./InstanceTable.vue?vue&type=script&lang=js"
export * from "./InstanceTable.vue?vue&type=script&lang=js"
import style0 from "./InstanceTable.vue?vue&type=style&index=0&id=7927155b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7927155b",
  null
  
)

export default component.exports